<ng-content select="[boxChipImage]"></ng-content>
<ng-content></ng-content>
<ng-content select="[boxChipRemove]"></ng-content>
